import { s, spacing } from '@/theme/tokens';

export const metricTrendCardCompactLayout = {
  minHeight: 96,
  chartHeight: 30,
  hideCornerIconBelowWidth: 480,
  headerPaddingX: s('lg'),
  headerPaddingTop: s('md'),
  headerPaddingBottom: s('xxs'),
  middleGridTemplateColumns: 'max-content minmax(0, 1fr)',
  middleColumnGap: s('sm'),
  middlePaddingY: s('xs'),
  valuePaddingX: s('lg'),
  valuePaddingRight: s('none'),
  valuePaddingY: s('xxs'),
  chartPaddingX: s('none'),
  chartPaddingLeft: s('none'),
  footerPaddingX: s('lg'),
  footerPaddingTop: s('sm'),
  footerPaddingBottom: s('md'),
  rowGap: s('lg'),
  rowGapPx: spacing.lg,
} as const;
